import { Button, Menu, MenuItem, Typography } from '@mui/material';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { AdminModal } from './AdminModal';
import { useExternalLinkContext } from '../context';
import Dialog from 'components/Dialog';

const removeKey = (obj: any, keyToRemove: string) => {
  const { [keyToRemove]: _, ...remainingProperties } = obj;
  return remainingProperties;
};

const DeleteModal = ({
  onSubmit,
  isOpen,
  setIsOpen,
}: {
  onSubmit: () => void;
  isOpen: boolean;
  setIsOpen: React.Dispatch<React.SetStateAction<boolean>>;
}) => {
  const { t } = useTranslation('common');
  return (
    <Dialog
      title={t('deleteExternalLink')}
      open={isOpen}
      buttons={
        <>
          <Button onClick={() => setIsOpen(false)} variant='outlined'>
            {t('cancel')}
          </Button>
          <Button onClick={() => onSubmit()} variant='contained' color='error'>
            {t('delete')}
          </Button>
        </>
      }
    >
      <Typography>{t('deleteExternalLinkConfirmation')}</Typography>
    </Dialog>
  );
};

export const AdminMenu = ({
  anchorEl,
  onClose,
  url,
}: {
  anchorEl: HTMLElement | null;
  onClose: () => void;
  url: string | null;
}) => {
  const { t } = useTranslation('common');
  const [adminModalOpen, setAdminModalOpen] = React.useState(false);
  const [deleteModalOpen, setDeleteModalOpen] = React.useState(false);
  const { preference, setPreference, preferenceKey } = useExternalLinkContext() ?? {};

  const handleClose = () => {
    onClose();
  };

  const open = Boolean(anchorEl);
  const id = open ? 'admin-external-link-popover' : undefined;

  const openAdminModal = () => {
    setAdminModalOpen(true);
    handleClose();
  };

  const openDeleteModal = () => {
    setDeleteModalOpen(true);
    handleClose();
  };

  const viewLink = () => {
    if (url) {
      window.open(url);
    }
  };

  const deleteLink = () => {
    if (!preferenceKey) {
      return null;
    }
    const updatedPreference = removeKey(preference, preferenceKey);
    setPreference(updatedPreference);
    handleClose();
  };

  return (
    <>
      <AdminModal isOpen={adminModalOpen} setIsOpen={setAdminModalOpen} />
      <DeleteModal
        isOpen={deleteModalOpen}
        setIsOpen={setDeleteModalOpen}
        onSubmit={() => {
          deleteLink();
          setDeleteModalOpen(false);
        }}
      />
      <Menu
        id={id}
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'right',
        }}
      >
        <MenuItem onClick={openAdminModal}>
          <Typography>{url ? t('updateExternalLink') : t('addExternalLink')}</Typography>
        </MenuItem>
        {url && (
          <MenuItem onClick={viewLink}>
            <Typography>{t('viewExternalLink')}</Typography>
          </MenuItem>
        )}
        {url && (
          <MenuItem onClick={openDeleteModal}>
            <Typography>{t('deleteExternalLink')}</Typography>
          </MenuItem>
        )}
      </Menu>
    </>
  );
};
